<template>
    <div class="info-message"
         :style="'--color: var(--color-' + status + '); --color-light: var(--color-'+ status + '-light); --color-dark: var(--color-' + status + '-dark)'">
        <svg v-if="status === 'warning'"  width="24" height="24" viewBox="0 0 24 24">
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
        </svg>
        <svg v-else width="24" height="24" viewBox="0 0 24 24">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
        </svg>
        <div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InfoMessage",
        props:{
            status: {
                type:String,
                default: 'warning'
            }
        }
    }
</script>

<style scoped lang="scss">
    .info-message{
        border-radius: var(--radius-big);
        padding: var(--s-s);
        display:flex;
        justify-content: flex-start;
        margin-bottom: var(--s-s);
        margin-top: 16px;

        svg{
            margin-right: var(--s-s);
            flex-shrink: 0;
        }

        // colors
        background: var(--color-light);
        border: 2px solid var(--color);
        color: var(--color-dark);

        path{
            fill: var(--color-dark);
        }
    }
</style>
